:host {
    display: block;
    position: relative;

    button {
        all: unset;
        align-items: center;
        cursor: pointer;
        display: flex;
        width: 100%;
        transition: outline-offset 0.1s linear;
        justify-content: space-between;
        height: 60px;
        border-bottom: 1px solid $color-grey-02-steel;
        background-color: transparent;

        > span {
            @include typo-ws-paragraph;

            color: $color-grey-01-dark;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        > .svg {
            color: $color-red;
            margin: 0 10px 0 12px;
            transition: transform 0.1s linear;

            &.rotate {
                transform: rotate(-180deg);
            }
        }

        &::after {
            background-color: $color-white;
        }

        &:focus,
        &:focus-visible {
            outline: 2px solid $color-grey-04-middle;
            outline-offset: 2px;
        }
    }
}

.svg {
    cursor: pointer;
    height: 24px;
    width: 24px;
    flex-shrink: 0;
}

sew-menu {
    left: 0;
    top: 65px;
}
